import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Users } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-gradient-to-br from-dark-teal to-[#112a2a] py-14 px-4 text-white relative overflow-hidden" data-id="element-133">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-135">
          <h2 className="text-3xl md:text-5xl font-black mb-4 text-soft-teal" data-id="element-136">
            Lo que cambia en 72 horas:
          </h2>
        </motion.div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10 mb-12" data-id="element-137">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/10 backdrop-blur-md p-6 rounded-3xl border border-white/20 flex-1 w-full max-w-sm" data-id="element-138">
            <span className="text-coral font-bold text-xl mb-2 block" data-id="element-139">
              Viernes
            </span>
            <p className="text-lg leading-relaxed" data-id="element-140">
              Tu hijo depende 100% de un pañal desechable.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.5
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="hidden md:flex items-center justify-center w-16 h-16 rounded-full bg-coral shrink-0" data-id="element-141">
            <ArrowRight size={32} className="text-white" data-id="element-142" />
          </motion.div>

          <div className="md:hidden flex justify-center w-full" data-id="element-143">
            <ArrowRight size={32} className="text-coral rotate-90" data-id="element-144" />
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-soft-teal text-dark-teal p-6 rounded-3xl shadow-xl flex-1 w-full max-w-sm transform md:scale-110" data-id="element-145">
            <span className="font-black text-xl mb-2 block" data-id="element-146">
              Lunes por la mañana
            </span>
            <p className="text-lg font-medium leading-relaxed" data-id="element-147">
              Camina hacia su salón de clases usando calzoncillos de algodón,
              capaz de reconocer la señal de su cuerpo y avisar a su maestra.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex flex-col items-center text-center bg-white/5 p-6 rounded-3xl border border-white/10 max-w-3xl mx-auto" data-id="element-148">
          <Users className="text-coral w-12 h-12 mb-4" data-id="element-149" />
          <p className="text-xl md:text-2xl font-medium leading-relaxed" data-id="element-150">
            Más de{' '}
            <span className="text-coral font-black text-3xl" data-id="element-151">500 familias</span>{' '}
            han pasado del caos a la independencia usando este micro-sistema de
            inmersión.
          </p>
        </motion.div>
      </div>

      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-[40rem] h-[40rem] bg-soft-teal/5 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" data-id="element-152"></div>
    </section>;
}